module.exports = __webpack_public_path__ + "components/weather-icon/static/daythunderstorm-1ae53742ae4984c555f6ed4a663cf45f.png";